module.exports = __webpack_public_path__ + "static/img/cont49 (2).e38294a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (2).jpg
// module id = Sk9E
// module chunks = 0